export enum LanguageEnum
{
    Catalan,
    Spanish,
    English,
    French
}